import { useAuth0 } from '@auth0/auth0-react'
import { DialogHeader, DialogTitle } from '@dfh-corp-sites/ui'
import { Subscribe } from '@react-rxjs/core'
import React, { FC } from 'react'

import {
  ConfigurableProductDetailsFragment,
  SimpleProductDetailsFragment,
} from '../../../graphql/magento'
import { Maybe, Money } from '../../../graphql/search'
import useSiteMetadata from '../../../hooks/useSiteMetadata'
import { useDispensaryContext } from '../../../lib/dispensaries'
import { displayAttribute } from '../../../utils/itemTools'
import { VariantPriceReactive, VariantPriceSkeleton } from '../details/ItemHeading'

export interface HeadingProps {
  item: ConfigurableProductDetailsFragment
  selectedVariant: SimpleProductDetailsFragment | null | undefined
  variantRetailPrice: Maybe<Money> | undefined
}

const Heading: FC<HeadingProps> = ({ item, selectedVariant = null, variantRetailPrice }) => {
  const npn = displayAttribute({ item, selectedVariant, attribute: 'natural_product_number' })
  const { featureFlags } = useSiteMetadata() ?? {}
  const { isAuthenticated } = useAuth0()
  const dispensary = useDispensaryContext()
  const anonymousCart = featureFlags?.anonymousCart ?? false
  const showPrice = isAuthenticated || !!dispensary || anonymousCart

  return (
    <DialogHeader className="text-center flex flex-col items-center gap-3 xl:gap-3.5 pb-5 xl:pb-6 px-2.5 md:px-5 pt-5 xl:pt-8">
      <span className="text-xs text-brand-navy py-1 px-3 xl:px-3.5 uppercase border border-brand-navy rounded-[80px]">
        SKU: {displayAttribute({ item, selectedVariant, attribute: 'sku' })?.toUpperCase()}
        {npn && <span>{`NPN: ${npn}`}</span>}
      </span>
      <DialogTitle className="text-2xl md:text-3xl xl:text-[32px] text-center">
        {item.name}
      </DialogTitle>
      {showPrice && (
        <Subscribe fallback={<VariantPriceSkeleton />}>
          <VariantPriceReactive
            item={item}
            selectedVariant={selectedVariant}
            retailPrice={variantRetailPrice}
          />
        </Subscribe>
      )}
      {item.variants?.length === 1 && (
        <h3>
          {item.variants[0]?.attributes
            ?.map((attribute) => attribute?.label ?? '')
            .filter(Boolean)
            .join(' ')}
        </h3>
      )}
    </DialogHeader>
  )
}

export default Heading
